import { useGameStore } from '../../game/store/GameStore'
import { useGodziDropStore } from '../../godziDrop/store/godziDropStore'
import { IGameInfoApi } from '../api/gameInfoApi'
import {
  ApiError,
  ErrorType,
  ga4Info,
  setErrorPopupData,
  useChipSetStore,
  usePlayerStore,
  useVoucherStore,
} from '@slot-nx/core'

export class GameInfoService {
  private _api: IGameInfoApi

  constructor(api: IGameInfoApi) {
    this._api = api
  }

  async getGameInfo() {
    try {
      const gameInfoResponse = await this._api.getGameInfo()
      if (gameInfoResponse.returnCode === 23) {
        throw new ApiError(ErrorType.SessionExpired)
      }
      usePlayerStore.setState({
        ...gameInfoResponse.player,
        balance: gameInfoResponse.player.balance,
        currency: gameInfoResponse.player.currency.replace(/k/gi, ''),
      })
      useGameStore.setState({
        defaultReelTable: gameInfoResponse.game.slotTable,
        multiplierReelInfo: gameInfoResponse.game.multiplierReelInfo,
        baseFreeGameCount: gameInfoResponse.game.baseFreeSpinCount,
        bonusFreeGameCount: gameInfoResponse.game.bonusFreeSpinCount,
        payTable: gameInfoResponse.game.payTable,
      })
      useChipSetStore.setState({
        currentIndex: gameInfoResponse.game.chipSet.findIndex(
          x => x === gameInfoResponse.game.defaultChipValue,
        ),
        chipSet: gameInfoResponse.game.chipSet,
      })
      useGodziDropStore.setState({
        eventInfo: gameInfoResponse.eventInfo,
      })
      if (gameInfoResponse.slotVoucherSummary !== null) {
        useVoucherStore.setState({
          tempSlotVoucher: gameInfoResponse.slotVoucherSummary,
        })
      }
      ga4Info.setPlayerId(gameInfoResponse.player.playerId)
    }
    catch (e) {
      if (e instanceof ApiError && e.type === ErrorType.SessionExpired) {
        setErrorPopupData(ErrorType.SessionExpired)
      }
      else {
        console.error(e)
        setErrorPopupData(ErrorType.SystemError)
      }
    }
  }
}
